<template>
    <div>
        <v-data-table
            dense
            :headers="headers"
            :items="castingReport"
            :loading="loading"
            disable-sort
            disable-pagination
            hide-default-footer>
            <template v-slot:[`item.code`]="{item}">
                <a href="#" @click="openInvoiceDisplayDialog({id: item.invoice_id})">
                    <v-badge inline :color="item.invoice_state == 'POSTED' ? 'success' : 'warning' " dot>{{item.code}}</v-badge>
                </a>
            </template>
            <template v-slot:[`item.customer`]="{item}">
                <a href="#" @click="openCustomerDisplayDialog({id: item.customer_id})">{{item.customer}}</a>
            </template>
            <template v-slot:[`item.quantity`]="{item}">
                {{ formatNumber(item.quantity, 2) }}
            </template>
            <template v-slot:[`item.price`]="{item}">
                {{ formatNumber(item.price, 2) }}
            </template>
            <template v-slot:[`item.subtotal`]="{item}">
                {{ formatNumber(item.subtotal, 2) }}
            </template>
            <template v-slot:[`item.total`]="{item}">
                <b>{{ formatNumber(item.total, 2) }}</b>
            </template>
            <template slot="body.append">
                <tr>
                    <td colspan="4"></td>
                    <td><b>{{ $t("total") }}</b></td>
                    <td><b>{{totalQuantity}}</b></td> <!-- Quantity --> 
                    <td></td>
                    <td><b>{{totalSubtotal}}</b></td> <!-- Discount --> 
                    <td><b>{{total}}</b></td> <!-- Total --> 
                </tr>
            </template>
        </v-data-table>
        <InvoiceDisplayDialog
            ref="invoiceDisplayDialog"/>
        <CustomerDisplayDialog
            ref="customerDisplayDialog"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import {formatNumber, formatMoney} from 'accounting';
import InvoiceDisplayDialog from '../Sales/InvoiceDisplayDialog';
import CustomerDisplayDialog from '../Sales/CustomerDisplayDialog';
import { sumBy } from 'lodash';
import { getTotal } from './../../utils/accounting'

export default {
    name: "CastingReportDataTable",
    components: {
        InvoiceDisplayDialog,
        CustomerDisplayDialog
    },
    props: {
        dateFrom: {
            required: true,
            type: String
        },
        dateTo: {
            required: true,
            type: String
        },
        branch_id: {
            type: Number
        }
    },
    data() {
        return {
            currency: "SDG",
            headers: [
                { text: this.$t('date'), value: "date" },
                { text: this.$t("invoice_number"), value: "code" },
                { text: this.$t("customer"), value: "customer" },
                { text: this.$t("item"), value: "item"},
                { text: this.$t("branch"), value: "branch"},
                { text: this.$t("quantity"), value: "quantity"},
                { text: this.$t("price"), value: "price" },
                { text: "Subtotal", value: "subtotal" },
                { text: this.$t("total"), value: "total" }
            ],
            castingReport: [],
            loading: false
        }
    },
    computed: {
        totalQuantity() {
            return formatNumber(getTotal(this.castingReport, "quantity"));
        },
        totalSubtotal() {
            return formatNumber(getTotal(this.castingReport, "subtotal"));
        },
        total() {
            return formatNumber(getTotal(this.castingReport, "total"));
        }
    },
    methods: {
        formatNumber,
        formatMoney,
        ...mapActions("sales/report", ["getCastingReport"]),
        getSumOf(field) {
           return parseFloat(sumBy(this.castingReport, o => o[field])); 
        },
        async submit() {
            this.loading = true;
            var result = await this.getCastingReport({date_from: this.dateFrom, date_to: this.dateTo, branch_id: this.branch_id});
            this.castingReport = result.data;
            this.loading = false;
        },
        openInvoiceDisplayDialog(params) {
            this.$refs.invoiceDisplayDialog.open(params);
        },
        openCustomerDisplayDialog(params) {
            this.$refs.customerDisplayDialog.open(params);
        }
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
    color: black;
}
a:hover {
    font-weight: bold;
}
</style>